import { KeyLabel, MOD } from './KeyLabel';
export const KeyLabelLithuanian_azerty: KeyLabel[] = [
  {
    code: 4,
    label: 'A',
  },
  {
    code: 5,
    label: 'B',
  },
  {
    code: 6,
    label: 'C',
  },
  {
    code: 7,
    label: 'D',
  },
  {
    code: 8,
    label: 'E',
    meta: [
      {
        label: '€',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 9,
    label: 'Š',
  },
  {
    code: 10,
    label: 'G',
  },
  {
    code: 11,
    label: 'H',
  },
  {
    code: 12,
    label: 'I',
  },
  {
    code: 13,
    label: 'J',
  },
  {
    code: 14,
    label: 'K',
  },
  {
    code: 15,
    label: 'L',
  },
  {
    code: 16,
    label: 'M',
  },
  {
    code: 17,
    label: 'N',
  },
  {
    code: 18,
    label: 'O',
  },
  {
    code: 19,
    label: 'P',
  },
  {
    code: 20,
    label: 'Ą',
  },
  {
    code: 21,
    label: 'R',
  },
  {
    code: 22,
    label: 'S',
  },
  {
    code: 23,
    label: 'T',
  },
  {
    code: 24,
    label: 'U',
  },
  {
    code: 25,
    label: 'V',
  },
  {
    code: 26,
    label: 'Ž',
  },
  {
    code: 27,
    label: 'Ū',
  },
  {
    code: 28,
    label: 'Y',
  },
  {
    code: 29,
    label: 'Z',
  },
  {
    code: 30,
    label: '!',
    meta: [
      {
        label: '1',
        modifiers: MOD.SFT,
      },
      {
        label: '1',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '@',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 31,
    label: '-',
    meta: [
      {
        label: '2',
        modifiers: MOD.SFT,
      },
      {
        label: '2',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '_',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 32,
    label: '/',
    meta: [
      {
        label: '3',
        modifiers: MOD.SFT,
      },
      {
        label: '3',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '#',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 33,
    label: ';',
    meta: [
      {
        label: '4',
        modifiers: MOD.SFT,
      },
      {
        label: '4',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '$',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 34,
    label: ':',
    meta: [
      {
        label: '5',
        modifiers: MOD.SFT,
      },
      {
        label: '5',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '§',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 35,
    label: ',',
    meta: [
      {
        label: '6',
        modifiers: MOD.SFT,
      },
      {
        label: '6',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '^',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 36,
    label: '.',
    meta: [
      {
        label: '7',
        modifiers: MOD.SFT,
      },
      {
        label: '7',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '&',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 37,
    label: '=',
    meta: [
      {
        label: '8',
        modifiers: MOD.SFT,
      },
      {
        label: '8',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '*',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 38,
    label: '(',
    meta: [
      {
        label: '9',
        modifiers: MOD.SFT,
      },
      {
        label: '9',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
    ],
  },
  {
    code: 39,
    label: ')',
    meta: [
      {
        label: '0',
        modifiers: MOD.SFT,
      },
      {
        label: '0',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: ']',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 45,
    label: '?',
    meta: [
      {
        label: '+',
        modifiers: MOD.SFT,
      },
      {
        label: '+',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: "'",
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 46,
    label: 'X',
    meta: [
      {
        label: '%',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 47,
    label: 'Į',
    meta: [
      {
        label: '{',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 48,
    label: 'W',
    meta: [
      {
        label: '}',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 50,
    label: 'Q',
    meta: [
      {
        label: '|',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 51,
    label: 'Ų',
  },
  {
    code: 52,
    label: 'Ė',
    meta: [
      {
        label: '"',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 53,
    label: '`',
    meta: [
      {
        label: '~',
        modifiers: MOD.SFT,
      },
      {
        label: '~',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '´',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 54,
    label: 'Č',
    meta: [
      {
        label: '„',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 55,
    label: 'F',
    meta: [
      {
        label: '“',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 56,
    label: 'Ę',
    meta: [
      {
        label: '(backslash)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 100,
    label: '<',
    meta: [
      {
        label: '>',
        modifiers: MOD.SFT,
      },
      {
        label: '>',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '–',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 542,
    label: '1',
  },
  {
    code: 543,
    label: '2',
  },
  {
    code: 544,
    label: '3',
  },
  {
    code: 545,
    label: '4',
  },
  {
    code: 546,
    label: '5',
  },
  {
    code: 547,
    label: '6',
  },
  {
    code: 548,
    label: '7',
  },
  {
    code: 549,
    label: '8',
  },
  {
    code: 550,
    label: '9',
  },
  {
    code: 551,
    label: '0',
  },
  {
    code: 557,
    label: '+',
  },
  {
    code: 565,
    label: '~',
  },
  {
    code: 612,
    label: '>',
  },
  {
    code: 4638,
    label: '1',
  },
  {
    code: 4639,
    label: '2',
  },
  {
    code: 4640,
    label: '3',
  },
  {
    code: 4641,
    label: '4',
  },
  {
    code: 4642,
    label: '5',
  },
  {
    code: 4643,
    label: '6',
  },
  {
    code: 4644,
    label: '7',
  },
  {
    code: 4645,
    label: '8',
  },
  {
    code: 4646,
    label: '9',
  },
  {
    code: 4647,
    label: '0',
  },
  {
    code: 4653,
    label: '+',
  },
  {
    code: 4661,
    label: '~',
  },
  {
    code: 4708,
    label: '>',
  },
  {
    code: 5120,
    label: '[',
  },
  {
    code: 5128,
    label: '€',
  },
  {
    code: 5150,
    label: '@',
  },
  {
    code: 5151,
    label: '_',
  },
  {
    code: 5152,
    label: '#',
  },
  {
    code: 5153,
    label: '$',
  },
  {
    code: 5154,
    label: '§',
  },
  {
    code: 5155,
    label: '^',
  },
  {
    code: 5156,
    label: '&',
  },
  {
    code: 5157,
    label: '*',
  },
  {
    code: 5159,
    label: ']',
  },
  {
    code: 5165,
    label: "'",
  },
  {
    code: 5166,
    label: '%',
  },
  {
    code: 5167,
    label: '{',
  },
  {
    code: 5168,
    label: '}',
  },
  {
    code: 5170,
    label: '|',
  },
  {
    code: 5172,
    label: '"',
  },
  {
    code: 5173,
    label: '´',
  },
  {
    code: 5174,
    label: '„',
  },
  {
    code: 5175,
    label: '“',
  },
  {
    code: 5176,
    label: '(backslash)',
  },
  {
    code: 5220,
    label: '–',
  },
];
